import React, { useState, useRef, useEffect } from "react";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import { useSelector } from "react-redux";
import * as PartnerService from "../../Services/Partner/PartnerService";
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import toast from "react-hot-toast";
import { FaCashRegister, FaInfoCircle, FaSearch, FaSpinner } from "react-icons/fa";
import ReactDatePicker from "react-datepicker";
import * as AccountService from '../../Services/Account/AccountService';
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";
import { formatAmount, LoadingMessage } from "../../Common/CommonVariables"
import "./RollingAdvanceComponent.css";
import CommonPagination from "../../Common/CommonPagination"

import { store } from '../../Store/store';
import { currencySymbols } from '../../Common/CommonVariables';


const RollingAdvanceComponent = () => {
    const [DepositRecMonthYear, setDepositRecMonthYear] = useState("");
    const selectedOrg = useSelector((state) => state.selectedOrganization);
    const [transactions, setTransactions] = useState([]);
    const [transactionsAmount, setTransactionsAmount] = useState(0);
    const [entriesTransactions, setEntriesTransactions] = useState(0);
    const [entriesRefundTransactions, setEntriesRefundTransactions] = useState(0);
    const [entriesTotalTransactions, setEntriesTotalTransactions] = useState(0);
    const [totalDeposit, setTotalDeposit] = useState(0);
    const [currentBalance, setCurrentBalance] = useState(0);
    const [ClosingBalance, setClosingBalance] = useState(0);
    const [totalCommissionCount, setTotalCommissionCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const selectedDateRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);
    const indexOfLastPatientRPT = currentPage * itemsPerPage;
    const indexOfFirstPatientRPT = indexOfLastPatientRPT - itemsPerPage;
    const currentTransactions = transactions.slice(indexOfFirstPatientRPT, indexOfLastPatientRPT);
    const userInfo = store.getState();

    const [showTooltip, setShowTooltip] = useState(false);

    // const tooltipRef = useRef(null);
    // const tooltipInstanceRef = useRef(null);

    // useEffect(() => {
    //     if (tooltipInstanceRef.current) {
    //         tooltipInstanceRef.current.dispose();
    //         tooltipInstanceRef.current = null;
    //     }
    //     if (tooltipRef.current) {
    //         let tooltipContent = '';
    //         if (entriesTransactions.length > 0) {
    //             tooltipContent += `<b>Transactions:</b> ${entriesTransactions.length}`;
    //         }
    //         if (entriesRefundTransactions.length > 0) {
    //             if (tooltipContent !== '') tooltipContent += '<br/>';
    //             tooltipContent += `<b>Refunds:</b> ${entriesRefundTransactions.length}`;
    //         }
    //         tooltipInstanceRef.current = new window.bootstrap.Tooltip(tooltipRef.current, {
    //             title: tooltipContent,
    //             html: true,
    //             placement: 'top',
    //             customClass: 'custom-tooltip',
    //             trigger: 'hover',
    //         });
    //     }
    //     return () => {
    //         if (tooltipInstanceRef.current) {
    //             tooltipInstanceRef.current.dispose();
    //             tooltipInstanceRef.current = null;
    //         }
    //     };
    // }, [entriesTransactions, entriesRefundTransactions]);

    // const isCurrentMonthAndYear = () => {
    //     const now = new Date();
    //     return (
    //         selectedDateTime.getMonth() === now.getMonth() &&
    //         selectedDateTime.getFullYear() === now.getFullYear()
    //     );
    // };



    const fetchPartnerTransaction = () => {
        if (!selectedOrg) {
            toast.error("No organization selected.");
            return;
        }

        if (!selectedDateTime) {
            toast.error("Date can't be null/empty.");
            return;
        }

        if (selectedDateTime > new Date()) {
            toast.error("Selected month & year cannot be in the future.");
            return;
        }

        setLoading(true);
        setSearchLoading(true);

        const requestData = {
            year: selectedDateTime.getFullYear().toString(),
            month: selectedDateTime.toLocaleString("default", { month: "long" }),
            registeredLocationId: 0,
            orgId: "0",
        };

        PartnerService.GetPartnerStatemntTransactionData(requestData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const filteredTransactions = data.Data.data.filter(
                        (d) => d.transactionDate || d.depositDate
                    );
                    const raDeposits = filteredTransactions.filter((d) => d.raDeposit > 0);
                    const calculatedTotalDeposit = raDeposits.reduce((sum, d) => sum + d.raDeposit, 0);
                    setEntriesTransactions(data.Data.data.filter(a => a.vid && !a.Is_VID_Proccessed_Refund));
                    setEntriesRefundTransactions(data.Data.data.filter(a => a.vid && a.Is_VID_Proccessed_Refund));
                    setEntriesTotalTransactions(data.Data.data.filter(a => a.vid));
                    setTransactionsAmount(data.Data.data.filter(a => a.vid && !a.Is_VID_Proccessed_Refund).reduce((sum, d) => sum + d.totalAmount, 0));
                    setTransactions(filteredTransactions);
                    setTotalDeposit(calculatedTotalDeposit);
                    setCurrentBalance(data.Data.currentBalance);
                    setClosingBalance(data.Data.closingBalance);
                    // const commissions = data.Data.data.filter(a => a.paymentfor === 'Commission').length;
                    // const reversals = data.Data.data.filter(a => a.paymentfor === 'Commission_Reversal').length;

                    // setTotalCommissionCount(commissions - reversals);

                    const commissionAmount = data.Data.data
                        .filter(a => a.transactionDate && a.paymentfor === 'Commission')
                        .reduce((sum, d) => sum + (d.totalAmount || 0), 0);

                    const commissionReversalAmount = data.Data.data
                        .filter(a => a.transactionDate && a.paymentfor === 'Commission_Reversal')
                        .reduce((sum, d) => sum + (d.totalAmount || 0), 0);

                    // Final Commission = Commission - Reversal
                    setTotalCommissionCount(commissionAmount - commissionReversalAmount);

                } else {
                    setTransactionsAmount([]);
                    setTransactions([]);
                    setEntriesTransactions(0);
                    setEntriesRefundTransactions(0);
                    setEntriesTotalTransactions([]);
                    setTotalDeposit(0);
                    setClosingBalance(0);
                    setCurrentBalance(0);
                    setTotalCommissionCount(0);
                }
            })
            .catch(() => {
                setTransactions([]);
                setTotalDeposit(0);
                setCurrentBalance(0);
                setClosingBalance(0);
                setTotalCommissionCount(0);
                toast.error("Something went wrong.");
            })
            .finally(() => {
                setDepositRecMonthYear(
                    `${selectedDateTime.toLocaleString("default", { month: "short" })}-${selectedDateTime.getFullYear()}`
                );
                setLoading(false);
                setSearchLoading(false);
            });
    };

    useEffect(() => {
        if (selectedOrg) {
            fetchPartnerTransaction();
        }
    }, [selectedOrg]);

    useEffect(() => {
        if (selectedOrg) {
            fetchPartnerTransaction();
        }
    }, [selectedDateTime]);

    // const cardColClass = isCurrentMonthAndYear() ? "col-md-4" : "col-md-3";

    const GetRevenueShareReport = (freePayId) => {
        // if (!freePayId) {
        //     toast.error("No document number available for this entry.");
        //     return;
        // }

        setSearchLoading(true);

        const requestData = {
            // jvDocNumber: freePayId
            jvDocNumber: freePayId
        };

        AccountService.GetRevenueShareReport(requestData)
            .then(({ data }) => {
                if (data.IsSuccess && data.Data?.invoicepdfURL) {
                    window.open(data.Data.invoicepdfURL, '_blank');
                } else {
                    toast.error("Unable to retrieve the report.");
                }
            })
            .catch(() => {
                toast.error("Error fetching revenue share report:");
            })
            .finally(() => {
                setSearchLoading(false);
            });
    }

    return (
        <CommonContainer icon={<FaCashRegister size={20} />} heading={<>Transactions</>} buttonText="" onButtonClick={() => { }}>
            {/* {loading && <LoadingSpinnerComponent />} */}
            <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                <label className="mb-0">Select Month:</label>

                <div className="position-relative">
                    <ReactDatePicker
                        selected={selectedDateTime}
                        onChange={(date) => setSelectedDateTime(date)}
                        showMonthYearPicker
                        dateFormat="MMMM yyyy"
                        placeholderText="Select month and year"
                        className="form-control month-picker-input"
                        maxDate={new Date()}
                        ref={selectedDateRef}
                    />
                    <Calendar
                        size={18}
                        className="position-absolute calendar custom-calendar-icon"
                        onClick={() => selectedDateRef.current.setFocus()}
                    />
                </div>

                <button
                    className="btn custom-sumbitbtn d-flex align-items-center justify-content-center custom-search-btn"
                    style={{ width: "38px", height: "35px", padding: "0" }}
                    onClick={fetchPartnerTransaction}
                    disabled={searchLoading}
                >
                    {searchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                </button>

                {searchLoading && <LoadingMessage />}
            </div>

            <div className="row g-2 pb-3">


                {/* Closing Balance Card */}
                {/* {!isCurrentMonthAndYear() && ( */}
                <div className={`${userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' ? 'col-12 col-lg-6 col-xl-3' : 'col-12 col-sm-6 col-xl-3'}`}>
                    <div className="card shadow-sm border-0 rounded-3 cardeven h-100" style={{ backgroundColor: '#007bff', color: '#fff' }}>
                        {/* <div className="card-body pl-2">
                                <h5 className="text-uppercase fw-semibold mb-2">
                                    Closing Balance <span style={{ fontSize: "12px" }}>{DepositRecMonthYear && `(${DepositRecMonthYear})`}</span>
                                </h5>
                                <p className="fs-5 mb-0">{formatAmount(ClosingBalance)}</p>
                            </div> */}
                        <div className="card-body pl-2">
                            <h5 className="text-uppercase fw-semibold mb-2">
                                Opening Balance
                                {/* <span style={{ fontSize: "12px" }}>{DepositRecMonthYear && `(${DepositRecMonthYear})`}</span> */}
                            </h5>
                            <p className="fs-5 mb-0">{formatAmount(ClosingBalance)}</p>
                        </div>
                    </div>
                </div>
                {/* )} */}

                {/* Deposit Card */}
                <div className={`${userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' ? 'col-12 col-sm-6 col-xl-2' : 'col-12 col-sm-6 col-xl-3'}`}>
                    <div className="card shadow-sm border-0 rounded-3 cardodd h-100" style={{ color: '#fff' }}>
                        <div className="card-body pl-2">
                            <h5 className="text-uppercase fw-semibold mb-2">
                                Deposits
                                {/* <span style={{ fontSize: "12px" }}>{DepositRecMonthYear && `(${DepositRecMonthYear})`}</span> */}
                            </h5>
                            <p className="fs-5 mb-0">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{totalDeposit}</p>
                        </div>
                    </div>
                </div>

                {/* Current Balance Card */}
                <div className={`${userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' ? 'col-12 col-sm-6 col-lg-4 col-xl-3' : 'col-12 col-sm-6 col-xl-3'}`}>
                    <div className="card shadow-sm border-0 rounded-3 cardodd h-100" style={{ color: '#fff' }}>
                        <div className="card-body pl-2">
                            <h5 className="text-uppercase fw-semibold mb-2">Current Balance</h5>
                            <p className="fs-5 mb-0">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{currentBalance}</p>
                        </div>
                    </div>
                </div>

                {/* Total Transactions Card */}
                <div className={`${userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' ? 'col-12 col-sm-6 col-lg-4 col-xl-2' : 'col-12 col-sm-6 col-xl-3'}`}>
                    <div className="card shadow-sm border-0 rounded-3 cardeven h-100" style={{ color: '#fff' }}>
                        <div className="card-body pl-2 position-relative">
                            <h5 className="text-uppercase fw-semibold mb-2">Transactions</h5>
                            <p className="fs-5 mb-0 d-flex align-items-start flex-wrap gap-1">
                                <span className="d-inline-flex align-items-center">
                                    {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{transactionsAmount} | {entriesTotalTransactions.length}
                                </span>

                                {entriesTotalTransactions.length > 0 && (
                                    // <i
                                    //     className="fas fa-info-circle text-white"
                                    //     data-bs-toggle="tooltip"
                                    //     data-bs-placement="top"
                                    //     data-bs-html="true"
                                    //     data-bs-custom-class="custom-tooltip"
                                    //     title={`<b>Transactions:</b> ${entriesTransactions.length}<br/><b>Refunds:</b> ${entriesRefundTransactions.length}`}
                                    //     style={{
                                    //         fontSize: "14px",
                                    //         cursor: "pointer",
                                    //         lineHeight: 1.4,
                                    //     }}
                                    // ></i>
                                    <span
                                        className="position-relative"
                                        onMouseEnter={() => setShowTooltip(true)}
                                        onMouseLeave={() => setShowTooltip(false)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <i className="fas fa-info-circle text-white" style={{ fontSize: "14px", lineHeight: 1.4 }}></i>
                                        {showTooltip && (
                                            <div style={{
                                                position: 'absolute',
                                                bottom: '125%',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                backgroundColor: '#333',
                                                color: '#fff',
                                                padding: '6px 10px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap',
                                                zIndex: 9999,
                                                pointerEvents: 'none',
                                            }}>
                                                <div><b>Transactions:</b> {entriesTransactions.length}</div>
                                                <div><b>Refunds:</b> {entriesRefundTransactions.length}</div>
                                            </div>
                                        )}
                                    </span>

                                )}
                            </p>


                        </div>
                    </div>
                </div>

                {/* Commission Card */}
                {userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' && (
                    <div className="col-12 col-sm-6 col-lg-4 col-xl-2">
                        <div className="card shadow-sm border-0 rounded-3 cardodd h-100" style={{ color: '#fff' }}>
                            <div className="card-body pl-2">
                                <h5 className="text-uppercase fw-semibold mb-2">Commission</h5>
                                <p className="fs-5 mb-0">{totalCommissionCount}</p>
                            </div>
                        </div>
                    </div>
                )}

            </div>

            <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "650px" }}>
                <table className="table table-bordered custom-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>VID</th>
                            <th>Patient Name</th>
                            <th>Organization</th>
                            {userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' && <th>Payment For</th>}
                            <th>Location</th>
                            <th>Amount</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentTransactions.length > 0 ? (
                            currentTransactions.map((item, index) => (
                                <tr key={index} className={item.raDeposit > 0 ? "fw-bold table-info" : ""}>
                                    <td className="text-nowrap text-center">
                                        {item.transactionDate || item.depositDate || "—"}
                                    </td>
                                    <td className="text-nowrap text-center">{item.vid || "—"}</td>
                                    <td className="text-nowrap">{item.patientName?.trim() || "—"}</td>
                                    <td className="text-nowrap">{item.organizationName || "—"}</td>
                                    {userInfo?.Partner_Account_Details?.MHL_Revenue_Model__c === 'Revenue Share' && (
                                        <td className="text-nowrap">
                                            <div className="d-flex align-items-center justify-content-center">
                                                {(item.paymentfor === 'Commission'
                                                    // || item.paymentfor === 'Commission_Reversal'
                                                ) && (
                                                        <span className="mb-1" title="View Report" style={{ cursor: "pointer" }} onClick={() => GetRevenueShareReport(item.freePayId)}>
                                                            <FaInfoCircle className="me-1" color="green" style={{ fontSize: "13px" }} />
                                                        </span>
                                                    )}
                                                {item.paymentfor || "—"}
                                            </div>
                                        </td>
                                    )}

                                    <td className="text-nowrap">{item.locationName || "—"}</td>

                                    {/* Amount cell with conditional color */}
                                    {/* <td
                                        className={`text-nowrap ${item.vid ? "text-danger" : "text-success"}`}
                                        style={{ textAlign: "right" }}
                                    >
                                        {item.vid
                                            ? <>- {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.totalAmount || 0}</>
                                            : item.raDeposit > 0
                                                ? <>+ {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.raDeposit} (Deposit)</>
                                                : <>+ {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.totalAmount || 0}</>}
                                    </td> */}

                                    <td className={`text-nowrap ${(item.vid && !item.Is_VID_Proccessed_Refund) ? "text-danger" : "text-success"}`} style={{ textAlign: "right" }}>
                                        {item.vid ? (
                                            item.Is_VID_Proccessed_Refund ? (
                                                <>
                                                    + {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
                                                    {item.totalAmount || 0} (Refund)
                                                </>
                                            ) : (
                                                <>
                                                    - {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
                                                    {item.totalAmount || 0}
                                                </>
                                            )
                                        ) : !item.Is_VID_Proccessed_Refund && item.raDeposit > 0 ? (
                                            <>
                                                + {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
                                                {item.raDeposit} (Deposit)
                                            </>
                                        ) : !item.Is_VID_Proccessed_Refund && item.totalAmount > 0 && item.raDeposit === 0 ? (
                                            <>
                                                + {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
                                                {item.totalAmount || 0}
                                            </>
                                        ) : (
                                            <>-</>
                                        )}
                                    </td>
                                    <td className="text-nowrap" style={{ textAlign: "right" }}>
                                        {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.balanceAmount ?? "—"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">
                                    No Transaction Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div>
                {transactions.length > itemsPerPage && (
                    <CommonPagination
                        pageList={transactions}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        setCurrentPage={setCurrentPage}
                    />
                )}
            </div>
        </CommonContainer>
    );
};

export default RollingAdvanceComponent;
